import React from 'react'
import propTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import noInformation02 from '../../../resources/images/noInformation/noInformation02.png'
import { useDataGridToolbarStyle } from '../../../resources/styles/CommonIndexStyles'

const DirectoryEmptyState = (props) => {
	const classes = useDataGridToolbarStyle()
	const displayMessage =
		props.searchQuery && props.searchQuery.trim().length > 0
			? `No assets found matching '${props.searchQuery}'.`
			: props.message
	return (
		<>
			<img src={noInformation02} alt='no-records' className={classes.noInformationImage} />
			<Typography align='center' className={classes.textColorNoData}>
				{displayMessage}
			</Typography>
		</>
	)
}

DirectoryEmptyState.propTypes = {
	message: propTypes.string.isRequired,
	/**
	 * Optional search query. When non-empty, overrides `message` with the
	 * search-specific copy "No assets found matching '...'".
	 */
	searchQuery: propTypes.string
}

export default DirectoryEmptyState
